/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_Transcript_Please_WaitInputs */

const en_loading_transcript_please_wait = /** @type {(inputs: Loading_Transcript_Please_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading transcript... please wait...`)
};

const fr_loading_transcript_please_wait = /** @type {(inputs: Loading_Transcript_Please_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement de la transcription... veuillez patienter...`)
};

const de_loading_transcript_please_wait = /** @type {(inputs: Loading_Transcript_Please_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transkript wird geladen... Bitte warten...`)
};

const it_loading_transcript_please_wait = /** @type {(inputs: Loading_Transcript_Please_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento della trascrizione... attendere prego...`)
};

const ru_loading_transcript_please_wait = /** @type {(inputs: Loading_Transcript_Please_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка текста... пожалуйста, подождите...`)
};

const es_loading_transcript_please_wait = /** @type {(inputs: Loading_Transcript_Please_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando transcripción... por favor espere...`)
};

const zh_cn2_loading_transcript_please_wait = /** @type {(inputs: Loading_Transcript_Please_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载文字稿……请稍候……`)
};

const ja_loading_transcript_please_wait = /** @type {(inputs: Loading_Transcript_Please_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トランスクリプトを読み込んでいます...お待ちください...`)
};

const hi_loading_transcript_please_wait = /** @type {(inputs: Loading_Transcript_Please_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ट्रांसक्रिप्ट लोड हो रहा है... कृपया प्रतीक्षा करें...`)
};

const pt_pt2_loading_transcript_please_wait = /** @type {(inputs: Loading_Transcript_Please_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando transcrição... aguarde...`)
};

/**
* | output |
* | --- |
* | "Loading transcript... please wait..." |
*
* @param {Loading_Transcript_Please_WaitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const loading_transcript_please_wait = /** @type {((inputs?: Loading_Transcript_Please_WaitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_Transcript_Please_WaitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_loading_transcript_please_wait(inputs)
	if (locale === "de") return de_loading_transcript_please_wait(inputs)
	if (locale === "it") return it_loading_transcript_please_wait(inputs)
	if (locale === "ru") return ru_loading_transcript_please_wait(inputs)
	if (locale === "es") return es_loading_transcript_please_wait(inputs)
	if (locale === "zh-CN") return zh_cn2_loading_transcript_please_wait(inputs)
	if (locale === "ja") return ja_loading_transcript_please_wait(inputs)
	if (locale === "hi") return hi_loading_transcript_please_wait(inputs)
	if (locale === "pt-PT") return pt_pt2_loading_transcript_please_wait(inputs)
	return en_loading_transcript_please_wait(inputs)
});